import React from 'react'
import abimg from '../../images/about.jpg'
import sign from '../../images/signeture.png'
import aboutMainImg from '../../images/about.jpg'; 
import customerIcon from '../../images/icons/customer.png';
import techIcon from '../../images/icons/tech.png';
import transparencyIcon from '../../images/icons/transparency.png';
import chrysaliscaccoonlogo from '../../images/chrysaliscaccoonlogo.png';

const About = () => {
    return (
        <>
        {/* SCROLL TARGET FOR BACK-TO-TOP */}
        <div id="scrool"></div>
        <section className="about-wrapper">

    {/* MAIN ABOUT SECTION */}
    <div className="about-block">
        <div className="text-area">

            <h2 className="about-title">About Legacy Community Services</h2>

            <p>
                <strong>Legacy Community Services</strong> offers comprehensive portfolio and on-site management, 
                financial oversight, architectural compliance, development consulting, and specialized project support.
            </p>

            <p>
                With over 35 years of combined experience across the region, our management team leads skilled community 
                managers who understand the challenges associations face. We pride ourselves on delivering exceptional 
                service with a personalized touch.
            </p>

            <p>
                Through strategic partnerships and investment in modern management software, we maintain a competitive 
                edge. Our commitment to innovation allows us to deliver top-tier solutions while keeping costs effective.
            </p>

            <p>
                Our mission is simple: responsive customer care, strong partnerships, and thriving communities.
            </p>
        </div>

        <img src={aboutMainImg} alt="About Us" />
    </div>


    {/* HIGHLIGHT ICON ROW */}
    <div className="about-highlights row">

        <div className="col-md-4">
        <img src={chrysaliscaccoonlogo} alt="Icon" />
            <h3>Customer Service</h3>
            <p>Exceptional support with professionalism, responsiveness, and a personal touch.</p>
        </div>

        <div className="col-md-4">
        <img src={chrysaliscaccoonlogo} alt="Icon" />
            <h3>Technology</h3>
            <p>Advanced portals and mobile app offer real-time access to essential information.</p>
        </div>

        <div className="col-md-4">
        <img src={chrysaliscaccoonlogo} alt="Icon" />
            <h3>Transparency</h3>
            <p>Complete financial and operational clarity through our digital tools.</p>
        </div>

    </div>


    {/* VISION SECTION */}
    <div className="about-vision">
        <h2>Our Vision</h2>
        <p>
            Our vision is to build strong partnerships with our clients through exceptional customer service 
            and complete transparency.
        </p>

    </div>

</section>
        </>

    );
};


export default About;